export const lightTheme = {
    bg: '#fff',
    primary: '#ff0072',
  
    nodeBg: '#f2f2f5',
    nodeColor: '#222',
    nodeBorder: '#222',
  
    minimapMaskBg: '#f2f2f5',
  
    controlsBg: '#fefefe',
    controlsBgHover: '#eee',
    controlsColor: '#222',
    controlsBorder: '#ddd',
  };
  
  export const darkTheme = {
    bg: '#000',
    primary: '#ff0072',
  
    nodeBg: '#343435',
    nodeColor: '#f9f9f9',
    nodeBorder: '#888',
  
    minimapMaskBg: '#25262b',
  
    controlsBg: '#25262b',
    controlsBgHover: '#676768',
    controlsColor: '#C1C2C5',
    controlsBorder: '#373a40',
  };

  export const tetTheme = {
    bg: '#fff',
    primary: '#ff0072',
  
    nodeBg: '#f2f2f5',
    nodeColor: '#222',
    nodeBorder: '#222',
  
    minimapMaskBg: '#f2f2f5',
  
    controlsBg: '#fefefe',
    controlsBgHover: '#eee',
    controlsColor: '#222',
    controlsBorder: '#ddd',
  };